export const OERI = {
    API: 'OERIValidationReport'
}

export const OERIAPIConstant = {
    getOeriReport: OERI.API + '/GetMatchOERIOpenTLRReport', 
    GetMatchOERIOpenTLRReportExcel: OERI.API + '/GetMatchOERIOpenTLRReportExcel', 
    GetOverdueTLRDetailsReport: OERI.API + '/GetOverdueTLRDetailsReport',
    GetOverdueTLRDetailsReportExcel: OERI.API + '/GetOverdueTLRDetailsReportExcel',
    GETOERIDISPAST60DAYSREPORT : OERI.API + '/GetOERIDisPast60DaysReport',
    GETOERIDISPAST60DAYSREPORTEXCEL : OERI.API + '/GetOERIDisPast60DaysReportExcel',
    GetOERIOrphanedTLRReport : OERI.API + '/GetOERIOrphanedTLRReport',
    GetOERIOrphanedTLRReportExcel : OERI.API + '/GetOERIOrphanedTLRReportExcel',
    GetOERIStatistics : OERI.API + '/GetOERIStatistics',
}